// extracted by mini-css-extract-plugin
module.exports = {"archiveBlock":"ArchiveBlock_archiveBlock__5UEq_","introContent":"ArchiveBlock_introContent__H4Ko0"};
module.exports.__checksum = "243c4ad1b93e"
